import { useState, useCallback } from 'react';
import { apiPath } from '../api';

type SubscribeSource = 'footer' | 'homepage' | 'popup' | 'checkout' | 'blog' | 'other';

export function useNewsletterSubscribe(source: SubscribeSource = 'footer') {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);
  const [done, setDone] = useState(false);

  const subscribe = useCallback(async () => {
    const trimmed = email.trim();
    if (!trimmed) {
      setMessage({ type: 'error', text: 'Please enter your email address.' });
      return;
    }
    setLoading(true);
    setMessage(null);
    try {
      const res = await fetch(apiPath('/newsletter/subscribe'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: trimmed, source, website: '' }),
      });
      let data: { success?: boolean; message?: string } = {};
      try {
        data = await res.json();
      } catch {
        data = {};
      }
      if (!res.ok || !data.success) {
        const msg = data.message || '';
        setMessage({
          type: 'error',
          text: msg.includes('CORS')
            ? 'Server connection blocked. Restart backend (npm run dev) and use http://localhost:5000'
            : msg || 'Could not subscribe. Please try again.',
        });
        return;
      }
      setDone(true);
      setEmail('');
      setMessage({ type: 'success', text: data.message || 'Thank you for subscribing!' });
    } catch {
      setMessage({ type: 'error', text: 'Network error. Please try again later.' });
    } finally {
      setLoading(false);
    }
  }, [email, source]);

  return { email, setEmail, loading, message, done, subscribe, setMessage, setDone };
}
